import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import NavigationDropdown from "./NavigationDropdown";

const DebtCollectionNav = ({ navItems, isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  // Update activeIndex based on current route
  useEffect(() => {
    const currentIndex = navItems.findIndex(
      (item) => item.path === location.pathname
    );
    setActiveIndex(currentIndex);
  }, [location.pathname, navItems]);

  const handleClick = (item, index) => {
    if (item.dropdown) {
      setOpenDropdownIndex(openDropdownIndex === index ? null : index);
      setDropdownOpen((prev) => !prev);
    } else {
      navigate(item.path);
      setDropdownOpen(false);
      setOpenDropdownIndex(null);
      setActiveIndex(index);
    }
  };

  return (
    <div
      className={`${
        isMobile ? "flex-col w-full" : "flex-row"
      } flex items-center gap-1 rounded-[5px] box-border overflow-hidden text-left text-base font-open-sans-ff-body-strong`}
    >
      {navItems.map((item, index) => {
        const isActive = activeIndex === index;

        return (
          <React.Fragment key={index}>
            <div
              className={`flex flex-row items-center rounded-3xs cursor-pointer justify-between py-2 px-3 gap-[10px] ${
                isMobile
                  ? "w-full border-b border-neutrals-neutral-100 last:border-b-0"
                  : "whitespace-nowrap"
              }
              ${
                isActive
                  ? "bg-neutrals-white-light text-black"
                  : "bg-transparent text-neutrals-neutral-300 hover:text-primary-primary-500"
              }
              transition-colors duration-200
              `}
              onClick={() => handleClick(item, index)}
            >
              <div className="relative font-semibold">{item.text}</div>
              {item.icon && (
                <img className="w-5 relative h-5" alt="" src={item.icon} />
              )}
            </div>

            {/* Mobile Dropdown */}
            {isMobile && isDropdownOpen && openDropdownIndex === index && (
              <div className="w-full">
                <NavigationDropdown isMobile={isMobile} />
              </div>
            )}
          </React.Fragment>
        );
      })}

      {/* Desktop Dropdown */}
      {!isMobile && isDropdownOpen && openDropdownIndex !== null && (
        <div className="absolute top-full left-0 mt-2 z-10">
          <NavigationDropdown isMobile={isMobile} />
        </div>
      )}
    </div>
  );
};

DebtCollectionNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      dropdown: PropTypes.bool,
      icon: PropTypes.string,
    })
  ).isRequired,
  isMobile: PropTypes.bool,
};

DebtCollectionNav.defaultProps = {
  isMobile: false,
};

export default DebtCollectionNav;
